import { payloadCodeTypeEnum } from "../../dataStruct";
import { parseCss } from "../../functions";

/** Local rows follow the published rows, so the last copy carries the override. */
export function uniquePositionedCargo<T extends { codeType: any; name: string; parameters: string }>(rows: T[]): T[] {
  const result: T[] = [];
  const indexByKey = new Map<string, number>();
  for (const row of rows) {
    const position = parseCss(row.parameters, "position");
    if (Number(row.codeType) !== payloadCodeTypeEnum.cargo || !position) {
      result.push(row);
      continue;
    }
    const key = JSON.stringify([position, row.name, parseCss(row.parameters, "opsMissionType") ?? ""]);
    const index = indexByKey.get(key);
    if (index === undefined) {
      indexByKey.set(key, result.length);
      result.push(row);
    } else {
      result[index] = row;
    }
  }
  return result;
}
